// extracted by mini-css-extract-plugin
export default {"grid":"Modal_grid__WbRKp","item":"Modal_item__iASxs","name":"Modal_name__G13fx","email":"Modal_email__JjXBf","itemContent":"Modal_itemContent__SoYD5"};